export default __webpack_public_path__ + "static/media/cursor.78b86af6.svg";